import React from "react";
import { Upload } from "antd";
import styles from "./index.module.css";
import ViewDocumentLink from "../ViewDocumentLink";
import { getDocumentFileId } from "../../../utils/document";
import { UploadCloud, FileText, X } from "lucide-react";

function Index({
  width,
  fileList,
  setFileList,
  onRemove,
  onChange,
  beforeUpload,
  showUploadList,
}) {
  const file = Array.isArray(fileList) ? fileList[0] : fileList;
  const hasUploadedDoc = file && getDocumentFileId(file);
  const fileName = file?.file_name || file?.name || "Uploaded document";

  if (hasUploadedDoc) {
    return (
      <div className={styles.wrapper} style={width ? { width } : undefined}>
        <div className={styles.uploadedState}>
          <div className={styles.fileInfo}>
            <div className={styles.fileIconWrap}>
              <FileText size={20} />
            </div>
            <div className={styles.fileMeta}>
              <span className={styles.fileName}>{fileName}</span>
              <ViewDocumentLink file={file} label="View document" />
            </div>
          </div>
          {onRemove && (
            <button
              type="button"
              className={styles.removeBtn}
              onClick={onRemove}
            >
              <X size={16} />
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper} style={width ? { width } : undefined}>
      <Upload
        className={styles.uploadFull}
        onRemove={onRemove}
        onChange={onChange}
        beforeUpload={beforeUpload}
        showUploadList={false}
        fileList={fileList}
      >
        <div className={styles.dropZone}>
          <div className={styles.dropZoneIcon}>
            <UploadCloud size={28} />
          </div>
          <div className={styles.dropZoneText}>
            <span className={styles.dropZoneTitle}>
              Drag & Drop or <span className={styles.browseLink}>Browse</span>
            </span>
            <span className={styles.dropZoneHint}>
              Supported: PDF, JPG, PNG
            </span>
          </div>
        </div>
      </Upload>
    </div>
  );
}

export default Index;
